export const QUICK_APPOINTMENT__SUMMERY_PRODUCT_TITLE = 'Select Services'
export const QUOTE_SUMMERY_PRODUCT_TITLE = 'Select Products and/or Services'
export const LOOKING_FOR_TIRE_PRICES_ID = 'lookingForTirePrices'
export const LOOKING_FOR_TIRE_PRICES_MESSAGE = 'Looking for tire prices?'
export const LOOKING_FOR_TIRE_PRICES_CATEGORY = 'Tire Services and Repair'
export const SHOP_TIRES_MESSAGE = 'Shop Tires'
export const FIVE_STEPPER = 'five'
export const THREE_STEPPER = 'three'
